module.exports = __webpack_public_path__ + "assets/img/qrCode3.6212de1d.jpg";